import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchNewDealerRequest, INewDealerRequestApiResponse, newDealerActionCreators, NewDealerActionKeys } from '..';
import { addressActionCreators } from '../../address';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { businessEntityActionCreators } from '../../businessEntity';
import { prospectActionCreators } from '../../prospects';
import { uiActionCreators } from '../../ui';
import * as api from '../newDealerApi';

function* fetchNewDealerRequest(action: FetchNewDealerRequest) {
  yield put(uiActionCreators.showFullPageLoading());
  const response: IApiExecuteRespone<INewDealerRequestApiResponse> = yield call(
    api.fetchNewDealerRequest,
    action.payload
  );

  if (!response.requestFailed && response.value) {
    yield put(uiActionCreators.hideFullPageLoading());
    yield put(newDealerActionCreators.setRequest(response.value.request));
    yield put(prospectActionCreators.setProspects([response.value.prospect]));
    yield put(addressActionCreators.setAddresses(response.value.prospect.addresses));
    yield put(
      businessEntityActionCreators.addAddresses([
        {
          addressIds: response.value.prospect.addresses.map(x => x.addressId),
          businessEntityId: response.value.prospect.businessEntityId
        }
      ])
    );

    yield put(
      businessEntityActionCreators.addNames([
        { businessEntityId: response.value.prospect.businessEntityId, name: response.value.prospect.name }
      ])
    );
  } else {
    // TODO - show error message
    yield put(uiActionCreators.hideFullPageLoading());
  }
}

export function* watchFetchNewDealerRequest() {
  yield takeEvery(NewDealerActionKeys.FETCH_NEW_DEALER_REQUEST, fetchNewDealerRequest);
}
